import Organizacion from "./organizacion";
import {FetConfig} from "../../services/familia/config";


export const Fet = (props) => {
    return (
        <Organizacion config={FetConfig} {...props}/>
    )
}